export var dataIsSurface = function dataIsSurface(data) {
  return (data === null || data === void 0 ? void 0 : data.type) && (data === null || data === void 0 ? void 0 : data.key) && (data === null || data === void 0 ? void 0 : data.fields);
};